import { Injectable, computed, inject, signal } from '@angular/core';

import { PlatformUser } from '../models/api.models';
import { ProfileService } from './profile.service';

/** Shared holder for the current user's profile projection; updated optimistically after avatar/name changes. */
@Injectable({ providedIn: 'root' })
export class MeProfileService {
  private readonly profileApi = inject(ProfileService);

  private readonly _profile = signal<PlatformUser | null>(null);
  readonly profile = this._profile.asReadonly();

  readonly avatarUrl = computed(() => this._profile()?.avatar_url ?? '');
  readonly firstName = computed(() => this._profile()?.first_name ?? '');
  readonly lastName = computed(() => this._profile()?.last_name ?? '');

  /** Loads the profile once (best-effort - the UI degrades to initials/empty). */
  load(): void {
    this.profileApi.getProfile().subscribe({
      next: (p) => this._profile.set(p),
      error: () => {
        /* best-effort: topbar falls back to the initials avatar */
      },
    });
  }

  setAvatarUrl(url: string): void {
    this._profile.update((p) => (p ? { ...p, avatar_url: url } : p));
  }

  setNames(firstName: string, lastName: string): void {
    this._profile.update((p) => (p ? { ...p, first_name: firstName, last_name: lastName } : p));
  }
}
